import { useContext } from 'react'
import { ClockContext, ClockControlsContext } from '../contexts/ClockContext'

export function useClock() {
  return useContext(ClockContext)
}

/** The clock's `setOverride` / `setSimulating` without `now` — prefer it over
 *  `useClock` when a component sets the clock but doesn't display it, since it
 *  never re-renders on a tick. */
export function useClockControls() {
  return useContext(ClockControlsContext)
}
